import React from "react";
import { Rocket } from "lucide-react";
import { JhText } from "designPackages/textPackage";
import { getBoostDetails } from "services/boostUtils";
import useResponseManagerV3PageStore from "../../../zustandStores/response-manager-v3/useResponseManagerV3PageStore";
import {
  JhTooltip,
  JhTooltipContent,
  JhTooltipProvider,
  JhTooltipTrigger
} from "designPackages/toolTip";

const JobBoostedCountdown = () => {
  const { jobData } = useResponseManagerV3PageStore(state => ({
    jobData: state.jobData
  }));

  const { timeLeftForExpiry, expiryDateRender } = getBoostDetails(
    jobData.boost_details
  );

  if (typeof timeLeftForExpiry === "string") {
    return null;
  }

  return (
    <JhTooltipProvider>
      <JhTooltip delayDuration={200}>
        <JhTooltipTrigger asChild>
          <div className="flex items-center justify-center gap-1 px-4 py-2 bg-info rounded-2xl">
            <Rocket size={16} className="text-foreground" />
            <JhText variant="subtitle4" as="span">
              Boosted:{" "}
              <JhText variant="caption2" as="span">
                {timeLeftForExpiry?.hours} hrs : {timeLeftForExpiry?.minutes}{" "}
                mins left
              </JhText>
            </JhText>
          </div>
        </JhTooltipTrigger>
        <JhTooltipContent variant="primary">
          <JhText className="text-white max-w-36" variant="caption1">
            <b> Keep an eye on your applications,</b> job boost ends at{" "}
            {expiryDateRender}
          </JhText>
        </JhTooltipContent>
      </JhTooltip>
    </JhTooltipProvider>
  );
};

export default JobBoostedCountdown;
